export const TEST_ID = 'warrantyCard';
